import mutations from './mutations';
import api from '../api';

export default {
  namespaced: true,
  state: {
    loading: false
  },
  mutations: {
    [mutations.LOADING](state) {
      state.loading = true;
    },
    [mutations.LOADED](state) {
      state.loading = false;
    }
  },
  actions: {
    getAll({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.dashboard
        .getAll(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error.response;
        });
    },
    getChart({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.dashboard
        .getChart(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error.response;
        });
    },
    getPercentage({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.dashboard
        .getPercentage(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error.response;
        });
    },
    getQuarter({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.dashboard
        .getQuarter(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error.response;
        });
    },
    getCalendar({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.dashboard
        .getCalendar(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error.response;
        });
    },
    getTopline({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.dashboard
        .getTopline(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error.response;
        });
    },
    getDashboardBo({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.dashboard
        .getDashboardBo(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error.response;
        });
    },
    searchIO({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.dashboard
        .searchIO(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error.response;
        });
    }
  },
  getters: {}
};
